    angular.module('shared-calendar', ['core', 'tasks', 'sms'])
        .factory('SharedCalendar', function ($resource) {
            return $resource('/crm/api/shared-calendar', {}, {
                users: {method: 'GET', isArray: true, url: "/crm/api/shared-calendar/users"},
                tasks: {method: 'GET', isArray: true, url: "/crm/api/shared-calendar/tasks"},
                share: {method: 'POST', url: "/crm/api/shared-calendar/share-calendar-batch"},
                reject: {method: 'POST', url: "/crm/api/shared-calendar/reject-calendar-batch"}
            });
        })
        .service('SharedCalendarService', function (modals) {
            //panel ADMIN
            this.addSettingModal = () => modals.open('app/task/shared-calendar/batch-add-modal.html', 'SharedCalendarBatchAddModalController', null, {size: 'md'}, "$ctrl");
            //panel ADMIN
            this.deleteSettingModal = () => modals.open('app/task/shared-calendar/batch-delete-modal.html', 'SharedCalendarBatchDeleteModalController', null, {size: 'md'}, "$ctrl");
        })
        .service('SharedCalendarCookieFilterService', function ($cookies) {
            let COOKIE_KEY = "shared-calendar-filters";
            let defaultFilters = {
                forMe: true,
                managedByMe: false,
                subscribed: false,
                status: ['SCHEDULED'],
                type: [],
                showInCalendar: true
            };

            let service = () => {

            };
            service.filters = $cookies.getObject(COOKIE_KEY) || defaultFilters;
            service.toggle = name => service.filters[name] = !service.filters[name];
            service.save = () => $cookies.putObject(COOKIE_KEY, service.filters);
            service.clear = () => {
                service.filters = {};
                $cookies.putObject(COOKIE_KEY, service.filters);
            };
            service.get = () => $cookies.getObject(COOKIE_KEY) || defaultFilters;

            return service;
        })
        .run(function (NavbarLeftMenu) {
            NavbarLeftMenu.add({
                authorities: "ROLE_TASKS",
                path: "/shared-calendar",
                ico: "fa fa-fw fa-calendar-o",
                name: 'calendar',
                order: 51
            });
        })
        .config(function ($stateProvider) {
            $stateProvider.state('sharedCalendar', {
                parent: 'app',
                url: '/shared-calendar',
                data: {
                    authorities: ['ROLE_TASKS']
                },
                views: {
                    'content@': 'sharedCalendar'
                }
            });
        });
